<div class="cash-out-result d-flex flex-column justify-content-between h-100">
    <div class="p-4" #receipt>
        <div class="text-center mb-4">
            <div class="summary-header-label">Cash {{ status === 'REDEEMED' ? 'paid to' : 'to pay' }} customer</div>
            <div class="amount">
                <span class="value">{{ finalCashAmount | number : '1.2-2' }}</span> <span class="currency">{{ voucherDetails.currency }}</span>
            </div>

            <span class="status-pill mt-2" [class.success]="status === 'REDEEMED'" [class.declined]="status === 'DECLINED'">
                <mat-icon [fontIcon]="status === 'REDEEMED' ? 'check_circle' : 'cancel'" style="font-size: 16px; width: 16px; height: 16px"></mat-icon>
                {{ status === 'REDEEMED' ? 'Cash out completed!' : 'Cash out declined' }}
            </span>

            <div class="meta mt-2">Ref #: {{ voucherDetails.reference_number }} &nbsp;|&nbsp; {{ today | date : 'd MMM y, h:mm a' }}</div>
        </div>

        <div class="customer-details-box mb-3">
            <div class="header-bg-title">Customer Details</div>
            <div class="body">
                <div class="avatar">{{ customerInitials }}</div>
                <div>
                    <div class="name">{{ customerFullName }}</div>
                    <div class="sub-text">{{ voucherDetails.user.email }}</div>
                </div>
            </div>
        </div>

        <div class="summary-box">
            <div class="summary-header">
                <div class="label">Summary</div>
            </div>
            <div class="summary-row">
                <span class="row-label">Voucher Code</span>
                <span>{{ voucherDetails.voucher_code }}</span>
            </div>
            <div class="summary-row">
                <span class="row-label">Transaction amount</span>
                <span>{{ voucherDetails.currency }} {{ voucherDetails.amount | number : '1.2-2' }}</span>
            </div>
            <div class="summary-row">
                <span class="row-label">Service fees</span>
                <span>{{ voucherDetails.currency }} {{ serviceFee | number : '1.2-2' }}</span>
            </div>
            <div class="summary-row highlighted" *ngIf="status === 'REDEEMED'">
                <span
                    >Credited to your wallet<span class="caption"
                        >{{ voucherDetails.currency }} {{ finalCashAmount | number : '1.2-2' }} cash back + {{ voucherDetails.currency }}
                        {{ voucherDetails.commission_amount | number : '1.2-2' }} commission</span
                    ></span
                >
                <span>{{ voucherDetails.currency }} {{ walletCredit | number : '1.2-2' }}</span>
            </div>
            <div class="summary-row highlighted" *ngIf="status === 'DECLINED'">
                <span>No funds were moved. The voucher remains active for another agent to redeem.</span>
            </div>
        </div>
    </div>

    <div class="footer-bar">
        <button mat-flat-button color="primary" class="rounded-pill download-btn" [disabled]="loading" (click)="downloadReceipt()">Download Receipt</button>
        <button mat-stroked-button color="primary" class="rounded-pill done-btn" [disabled]="loading" (click)="done()">Done</button>
    </div>

    <div class="loading-overlay" *ngIf="loading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
</div>
